import React from 'react';
import { motion } from 'framer-motion';

const HeroSection = () => (
  <motion.section
    className="relative flex flex-col items-center justify-center text-center py-16 md:py-20 px-2 md:px-4 bg-background overflow-hidden"
    initial={{ opacity: 0, y: 40 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, ease: 'easeOut' }}
  >
    <img src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1200&q=80" alt="Construction Site" className="absolute inset-0 w-full h-full object-cover opacity-20 pointer-events-none" />
    <div className="relative z-10 max-w-2xl mx-auto w-full">
      <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold text-primary mb-4 leading-tight">Procure Cement & Construction Materials with Confidence</h1>
      <p className="text-base sm:text-lg md:text-xl text-primary mb-8">Reliable supply. Transparent pricing. Built for real estate developers.</p>
      <a href="#lead-capture" className="inline-block w-full sm:w-auto px-6 py-3 bg-accent text-white rounded-xl shadow-soft font-semibold text-base sm:text-lg hover:bg-primary transition">Get Started</a>
    </div>
  </motion.section>
);

export default HeroSection; 